/**
 * Permissions Utility
 * Handles role and permission checking for ACL
 */

import { UserRole, Permission } from '../types/auth'
import { User, Admin } from '../lib/api/types'

/**
 * Check if user has specific role
 */
export function hasRole(
  role: UserRole | null,
  requiredRole: UserRole | UserRole[]
): boolean {
  if (!role) return false
  
  if (Array.isArray(requiredRole)) {
    return requiredRole.includes(role)
  }
  
  return role === requiredRole
}

/**
 * Check if user has specific permission
 * This is a placeholder for future ACL implementation
 * Can be extended to check user-specific permissions from API
 */
export function hasPermission(
  user: User | Admin | null,
  role: UserRole | null,
  _permission: Permission
): boolean {
  if (!user || !role) return false
  
  // Admin has all permissions
  if (role === 'admin') {
    return true
  }
  
  // For users, check specific permissions
  // This can be extended based on user.role or user.ai_access_level
  // Example: if (permission === Permissions.CAMPAIGNS_CREATE) return user.role === 'manager'
  
  // For now, users have basic permissions
  return true
}

/**
 * Check if user can access admin features
 */
export function isAdmin(role: UserRole | null): boolean {
  return role === 'admin'
}

/**
 * Check if user can access user features
 */
export function isUser(role: UserRole | null): boolean {
  return role === 'user'
}

